"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Service pro tisk štítků a obálek. Generated from cz.marbes.api.dokument.v1.obalky.ObalkaService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-06-17T17:59:10Z                      #

// ##############################################################

var ObalkaApi = function () {
  function ObalkaApi() {
    (0, _classCallCheck3.default)(this, ObalkaApi);
  }

  (0, _createClass3.default)(ObalkaApi, null, [{
    key: "tiskTestovaciStranky",

    /**
     * Vrací testovací stránku.
     *
     * @param pageOffset posun tisku
     * @return testovací stránka
     */
    value: function tiskTestovaciStranky(pageOffset) {
      var uri = serverContextPath + "/api/dokumenty/v1/obalky/testovaci/stranka/stream";
      var params = {};
      return (0, _generateUrl2.default)(uri, params, true);
    }

    /**
     * 
     *
     * @param sablonaKod jednoznačný identifikátor použité šablony
     * @return instance vyplněná dle zvolené šablony
     */

  }, {
    key: "createTiskAdresMetaDefault",
    value: function createTiskAdresMetaDefault(sablonaKod) {
      var uri = serverContextPath + ("/api/dokumenty/v1/obalky/sablona/" + sablonaKod + "/create");
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, 0, headers));
    }

    /**
     * Vrácí seznam nakonfigurovaných adresních štítků.
     *
     * @return seznam adresních štítků
     */

  }, {
    key: "getSablony",
    value: function getSablony() {
      var uri = serverContextPath + "/api/dokumenty/v1/obalky/sablony";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vytiskne adresní údaje podle zadaných metadat a položek.
     *
     * @param sablonaKod jednoznačný identifikátor použité šablony
     * @param stitky štítky, které budeme tisknout
     * @param odesilatelId id subjektu odesílatele - odesílatel pro tisk na obálku, při null bude odesílatel nevyplněn
     * @param meta další vlastnosti pro tisk obálek, doplňující a řídící údaje tisku, pokud bude předán {@code null} budou použity prázdné hodnoty
     * @param pageOffset nastavení posunu stránky (vyrovnání chyby podavače), při null bude posun 0 v obou směrech
     * @return Renderované štítky ve formátu PDF
     */

  }, {
    key: "tisk",
    value: function tisk(sablonaKod, stitky, odesilatelId, meta, pageOffset) {
      var uri = serverContextPath + ("/api/dokumenty/v1/obalky/sablona/" + sablonaKod + "/stream");
      var params = { odesilatelId: odesilatelId, meta: meta, pageOffset: pageOffset };
      return (0, _generateUrl2.default)(uri, params, true);
    }

    /**
     * Vytiskne testovací štítek s umělými daty.
     *
     * @param sablonaKod kód šablony
     * @param pageOffset posun tisku
     * @return testovací štítek
     */

  }, {
    key: "zkusebniTisk",
    value: function zkusebniTisk(sablonaKod, pageOffset) {
      var uri = serverContextPath + ("/api/dokumenty/v1/obalky/testovaci/sablona/" + sablonaKod + "/stream");
      var params = { pageOffset: pageOffset };
      return (0, _generateUrl2.default)(uri, params, true);
    }

    /**
     * Najde konkrétní šablonu dle kódu.
     *
     * @param sablonaKod kód šablony
     * @return šablona
     */

  }, {
    key: "getObalkaSablonaByKod",
    value: function getObalkaSablonaByKod(sablonaKod) {
      var uri = serverContextPath + ("/api/dokumenty/v1/obalky/sablona/" + sablonaKod);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }
  }]);
  return ObalkaApi;
}();

exports.default = ObalkaApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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